export default "__VITE_ASSET__DOkNZuOD__"